import React from "react";
import { bool, func, node, oneOf, string, number } from "prop-types";
import { useTheme, darken } from "@mui/material/styles";

import { Badge, Box, Button, Typography } from "@mui/material";
import { Link } from "react-router";
import { cardHover, baseCardStyle } from "../../component-styles";

const NavButton = ({
  href = null,
  linkHref = null,
  linkText = "",
  linkDescription,
  linkIcon = null,
  startIconBg = false,
  endIcon,
  newCount = 0,
  variant = "default",
  handleClick,
  target,
}) => {
  const { palette } = useTheme();

  const variantColor = variant === "dark" ? palette.common.black : palette.secondary.main;

  return (
    <Button
      href={href || undefined}
      component={linkHref ? Link : undefined}
      to={linkHref || undefined}
      target={target || undefined}
      onClick={handleClick}
      variant="outlined"
      startIcon={linkIcon}
      endIcon={endIcon}
      fullWidth={true}
      key={linkText}
      sx={(theme) => ({
        ...baseCardStyle(theme.palette),
        ...cardHover(theme.palette),
        position: "relative",
        "& svg": {
          fontSize: "1.6rem !important",
        },
        "& .MuiButton-endIcon svg": {
          color: "#CCE3F5",
        },
      })}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          flex: 1,
          whiteSpace: "pre-wrap",
          color: variantColor,
          paddingLeft: "10px",
        }}
      >
        {startIconBg && (
          <Box
            sx={{
              position: "absolute",
              left: 0,
              width: "45px",
              top: 0,
              bottom: 0,
              zIndex: 0,
              backgroundColor: palette.secondary.main,
            }}
          />
        )}
        <Typography
          component="span"
          variant="h4"
          sx={{
            color: "inherit",
            flexGrow: "1",
            lineHeight: "1",
            fontWeight: 500,
          }}
        >
          {linkText}
        </Typography>
        {linkDescription && (
          <Typography
            component="span"
            sx={{
              color: "inherit",
              fontSize: "16px",
              lineHeight: "1",
            }}
          >
            {linkDescription}
          </Typography>
        )}
      </Box>
      {newCount > 0 && (
        <Badge
          color="primary"
          badgeContent={`${newCount} new`}
          sx={(theme) => ({
            position: "absolute",
            top: "8px",
            right: "8px",
            "& .MuiBadge-badge": {
              position: "static",
              transform: "none",
              textTransform: "uppercase",
              fontWeight: 700,
              letterSpacing: ".03em",
              fontSize: 10,
              [theme.breakpoints.up("md")]: {
                fontSize: 11,
              },
              background: darken(theme.palette.primary.main, 0.3),
              border: `1px solid ${theme.palette.common.white}`,
              color: theme.palette.common.white,
            },
          })}
        />
      )}
    </Button>
  );
};

NavButton.propTypes = {
  href: string,
  linkHref: string,
  linkText: string,
  linkDescription: node,
  linkIcon: node,
  startIconBg: bool,
  endIcon: node,
  newCount: number,
  variant: oneOf(["default", "dark"]),
  handleClick: func,
  target: string,
};

export default NavButton;
